<div class="container-fluid pro-board">

  <!-- ====== HEADER DEL COMPONENTE ====== -->
  <div class="pb-header rounded">
    <div class="row align-items-center">
      <div class="col-md-1 text-center">
        <i class="fa-solid fa-columns fa-2xl"></i>
      </div>

      <div class="col-md-7">
        <div class="pb-header-meta">
          <span class="pb-pulse" *ngIf="sprintActual?.PRO32EST === 'A'">Sprint activo</span>
          <span *ngIf="sprintActual?.PRO32FEI">· 📅 {{ sprintActual.PRO32FEI }} → {{ sprintActual.PRO32FEF }}</span>
          <span *ngIf="sprintActual?.PRO32FEF">· ⏱ {{ diasRestantes(sprintActual.PRO32FEF) }}</span>
          <span>· {{ totales.totalCards }} tarjetas</span>
        </div>

        <div class="pb-header-title">
          <i class="fa-solid fa-flag-checkered me-1"></i>
          {{ sprintActual?.PRO32NOM || 'Tablero' }}
          <span class="pb-header-sub" *ngIf="header.PRO01DES">· {{ header.PRO01DES }}</span>
        </div>

        <div class="pb-header-goal" *ngIf="sprintActual?.PRO32GOL">
          <b>Goal:</b> {{ sprintActual.PRO32GOL }}
        </div>

        <div class="pb-header-sprint d-flex align-items-center mt-2">
          <label class="pb-label me-2">Sprint:</label>
          <select class="form-select form-select-sm pb-sel-sprint"
                  [value]="PRO32COD"
                  (change)="cambiarSprint($any($event.target).value)">
            <option *ngFor="let s of sprints" [value]="s.PRO32COD">
              {{ s.PRO32NOM }}
              <ng-container *ngIf="s.PRO32EST === 'A'"> (activo)</ng-container>
              <ng-container *ngIf="s.PRO32EST === 'P'"> (planeado)</ng-container>
              <ng-container *ngIf="s.PRO32EST === 'C'"> (cerrado)</ng-container>
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-4">
        <div class="pb-capacity">
          <div class="d-flex justify-content-between">
            <span class="pb-label">Commit / Capacidad</span>
            <span><b>{{ sprintActual?.PRO32SPC || 0 }} SP</b> / {{ sprintActual?.PRO32CAP || 0 }} SP</span>
          </div>
          <div class="progress pb-progress mt-1">
            <div class="progress-bar bg-primary" [style.width.%]="porcentajeCommit()"></div>
          </div>

          <div class="pb-mini-stats">
            <div><b>{{ totales.doneCards }}</b><span>Cerrados</span></div>
            <div><b>{{ totales.totalCards - totales.doneCards }}</b><span>En curso</span></div>
            <div class="text-danger"><b>{{ totales.doneSP }}</b><span>SP done</span></div>
          </div>

          <div class="d-flex gap-1 mt-2" *ngIf="permisos.CLOSE_SPRINT === 'S' && sprintActual?.PRO32EST === 'A'">
            <button class="btn btn-sm btn-primary flex-fill" (click)="cerrarSprintActual()">
              <i class="fa-solid fa-flag-checkered me-1"></i>Cerrar sprint
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- ====== TOOLBAR ====== -->
  <div class="pb-toolbar">
    <div class="pb-toolbar-left">
      <label class="pb-label me-1">Agrupar por:</label>
      <div class="btn-group btn-group-sm" role="group">
        <button class="btn pb-btn-group"
                [class.active]="groupBy === 'ESTADO'"
                (click)="cambiarGroupBy('ESTADO')">
          <i class="fa-solid fa-list-check me-1"></i>Estado
        </button>
        <button class="btn pb-btn-group"
                [class.active]="groupBy === 'USUARIO'"
                (click)="cambiarGroupBy('USUARIO')">
          <i class="fa-solid fa-user me-1"></i>Usuario
        </button>
      </div>

      <span class="pb-divider"></span>

      <button class="btn btn-sm btn-light pb-chip"
              [class.active]="soloMias"
              (click)="toggleSoloMias()">
        <i class="fa-solid fa-user-check me-1"></i>Solo mias
      </button>

      <span class="pb-divider"></span>

      <label class="pb-label me-1">Swimlane:</label>
      <select class="form-select form-select-sm pb-sel-swim"
              [value]="swimlane"
              (change)="cambiarSwimlane($any($event.target).value)">
        <option value="">Sin agrupar</option>
        <option value="PRO23EPI">Por epica</option>
        <option value="PRO23PRI">Por prioridad</option>
        <option value="PRO30COD">Por tipo</option>
      </select>
    </div>

    <div class="pb-toolbar-right">
      <button class="btn btn-sm btn-outline-primary"
              *ngIf="permisos.ATTACH_CARD === 'S'"
              (click)="abrirModalAttach()">
        <i class="fa-solid fa-link me-1"></i>Agregar existente
      </button>

      <div class="input-group input-group-sm pb-search">
        <span class="input-group-text"><i class="fa fa-search"></i></span>
        <input class="form-control" placeholder="Buscar en este tablero..." [(ngModel)]="busqueda">
      </div>
      <button class="btn btn-sm btn-light ms-1" title="Refrescar" (click)="refrescar()">
        <i class="fa-solid fa-arrows-rotate"></i>
      </button>
      <button class="btn btn-sm btn-secondary ms-1" (click)="emitirCancelar()">
        <i class="fa-solid fa-xmark me-1"></i>Cerrar
      </button>
    </div>
  </div>


  <!-- ====== TABLERO (Angular CDK DragDrop, sin Syncfusion) ====== -->
  <ng-container *ngIf="!cargando; else loading">

    <div *ngIf="columnas.length === 0" class="alert alert-warning mt-3">
      <ng-container *ngIf="groupBy === 'ESTADO'">
        No hay estados configurados en el catalogo PRO31ARC. Agreguelos desde Configuracion.
      </ng-container>
      <ng-container *ngIf="groupBy === 'USUARIO'">
        Este tablero no tiene tarjetas asignadas a usuarios.
      </ng-container>
    </div>

    <!-- Columnas dinamicas -->
    <div class="pb-columns" *ngIf="columnas.length > 0">
      <div *ngFor="let col of columnas; trackBy: trackByCol"
           class="pb-col"
           [class.pb-wip-warn]="wipExcedido(col)">

        <!-- Header de columna -->
        <div class="pb-col-head">
          <span class="pb-col-name">{{ col.label || '(sin asignar)' }}</span>
          <span class="pb-col-count">{{ cuentaCol(col) }}</span>
          <span class="pb-col-sp">{{ spCol(col) }} SP</span>
          <span class="pb-col-wip" *ngIf="col.wip != null">/ {{ col.wip }}</span>
        </div>

        <!-- Body de la columna (drop zone CDK) -->
        <div class="pb-col-body"
             cdkDropList
             [id]="dropListId(col.key)"
             [cdkDropListData]="cardsDeColumna(col.key)"
             [cdkDropListConnectedTo]="dropListIds()"
             [cdkDropListDisabled]="permisos.MOVE_CARD !== 'S'"
             (cdkDropListDropped)="onDrop($event, col)">

          <div *ngFor="let card of cardsDeColumna(col.key); trackBy: trackByCard"
               class="pb-card"
               [ngClass]="prioridadClase(card.PRO23PRI)"
               cdkDrag
               [cdkDragData]="card"
               [cdkDragDisabled]="permisos.MOVE_CARD !== 'S'">

            <!-- Preview que sigue al cursor durante el drag -->
            <div *cdkDragPreview class="pb-card pb-card-preview" [ngClass]="prioridadClase(card.PRO23PRI)">
              <div class="pb-card-top">
                <span class="pb-card-tipo" [style.background]="card.PRO30COL || '#7a869a'">
                  {{ (card.PRO30COD || 'T').substring(0,1) }}
                </span>
                <span class="pb-card-key">PRO-{{ card.PRO23COD }}</span>
              </div>
              <div class="pb-card-title">{{ card.PRO23TIT }}</div>
            </div>

            <!-- Placeholder en la posicion original mientras se arrastra -->
            <div *cdkDragPlaceholder class="pb-card-placeholder"></div>

            <div class="pb-card-top">
              <span class="pb-card-tipo" [style.background]="card.PRO30COL || '#7a869a'"
                    [title]="card.PRO30DES">{{ (card.PRO30COD || 'T').substring(0,1) }}</span>
              <span class="pb-card-key">PRO-{{ card.PRO23COD }}</span>
              <span class="pb-card-epic ms-auto" *ngIf="card.PRO23EPI">⤴ EPIC-{{ card.PRO23EPI }}</span>
            </div>

            <div class="pb-card-title">{{ card.PRO23TIT }}</div>
            <div class="pb-card-desc" *ngIf="!vistaCompacta && card.PRO23DES">{{ card.PRO23DES }}</div>

            <div class="pb-card-progress" *ngIf="card.PRO23PRG && card.PRO23PRG > 0">
              <div class="pb-card-progress-bar">
                <div class="pb-card-progress-fill" [style.width.%]="card.PRO23PRG"></div>
              </div>
              <span>{{ card.PRO23PRG }}%</span>
            </div>

            <div class="pb-card-bot">
              <span class="pb-card-prio">{{ prioridadIcon(card.PRO23PRI) }}</span>
              <span class="pb-card-sev" *ngIf="card.PRO23SEV === 'C' || card.PRO23SEV === 'M'">
                {{ card.PRO23SEV === 'C' ? 'Critica' : 'Mayor' }}
              </span>
              <span class="pb-card-sp" *ngIf="card.PRO23SP">{{ card.PRO23SP }} SP</span>
              <span class="pb-card-due" *ngIf="card.PRO23FVE">⏰ {{ card.PRO23FVE }}</span>
              <span class="pb-card-avatar"
                    [style.background]="colorUsuario(card.S00USR)"
                    [title]="card.S00USR">
                {{ inicialesUsuario(card.S00USR) }}
              </span>

              <span class="pb-card-menu dropdown ms-1" *ngIf="permisos.DETACH_CARD === 'S'">
                <button class="btn btn-sm btn-link pb-card-menu-btn"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        title="Acciones">⋯</button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li><a class="dropdown-item small" (click)="detachCard(card)">
                    <i class="fa-solid fa-link-slash me-1"></i>Quitar del tablero
                  </a></li>
                </ul>
              </span>
            </div>
          </div>

          <!-- Mensaje cuando la columna esta vacia -->
          <div class="pb-col-empty" *ngIf="cardsDeColumna(col.key).length === 0">
            Sin tarjetas
          </div>

          <!-- Quick add inline -->
          <button class="pb-col-quickadd-btn"
                  *ngIf="permisos.CREATE_CARD === 'S' && quickAddColumnKey !== col.key"
                  (click)="abrirQuickAdd(col)">
            <i class="fa fa-plus me-1"></i>Crear tarjeta
          </button>
          <div class="pb-col-quickadd-form" *ngIf="quickAddColumnKey === col.key">
            <input class="form-control form-control-sm"
                   placeholder="Titulo de la tarjeta..."
                   [(ngModel)]="quickAddText"
                   (keyup.enter)="confirmarQuickAdd()"
                   (keyup.escape)="cancelarQuickAdd()"
                   autofocus>
            <div class="d-flex gap-1 mt-1">
              <button class="btn btn-sm btn-success flex-fill" (click)="confirmarQuickAdd()">Crear</button>
              <button class="btn btn-sm btn-light" (click)="cancelarQuickAdd()">×</button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </ng-container>

  <ng-template #loading>
    <div class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-2xl"></i>
      <div>Cargando tablero...</div>
    </div>
  </ng-template>


  <!-- ====== STATUS BAR ====== -->
  <div class="pb-statusbar" *ngIf="!cargando">
    <div class="pb-stat" *ngFor="let t of totales.porColumna">
      <span class="pb-stat-dot" [ngClass]="'pb-cat-' + (t.cat || 'PROCESS').toLowerCase()"></span>
      <span class="pb-stat-name">{{ t.label }}</span>
      <b class="ms-1">{{ t.sp }} SP</b>
      <span class="text-muted ms-1">({{ t.count }})</span>
    </div>
    <span class="pb-statusbar-sep"></span>
    <span class="pb-stat text-muted">
      <kbd>c</kbd> Crear &nbsp; <kbd>/</kbd> Buscar &nbsp; <kbd>m</kbd> Asignarme &nbsp; <kbd>Enter</kbd> Abrir
    </span>
  </div>


  <!-- ====== MODAL: Agregar tarjeta existente ====== -->
  <div class="pb-modal-overlay" *ngIf="modalAttachVisible" (click)="cerrarModalAttach()"></div>
  <div class="pb-modal" *ngIf="modalAttachVisible">
    <div class="pb-modal-header">
      <h5 class="m-0"><i class="fa-solid fa-link me-1"></i>Agregar tarjeta existente</h5>
      <button class="btn-close" (click)="cerrarModalAttach()"></button>
    </div>
    <div class="pb-modal-body">
      <div class="d-flex gap-2 mb-2">
        <div class="input-group input-group-sm flex-fill">
          <span class="input-group-text"><i class="fa fa-search"></i></span>
          <input class="form-control"
                 placeholder="Buscar por titulo o codigo PRO-..."
                 [(ngModel)]="modalAttachQ"
                 (keyup.enter)="buscarCardsDisponibles()">
          <button class="btn btn-primary btn-sm" (click)="buscarCardsDisponibles()">Buscar</button>
        </div>
        <div class="form-check form-switch align-self-center">
          <input class="form-check-input" type="checkbox" id="proSoloEsteProy"
                 [(ngModel)]="modalAttachSoloProy"
                 (change)="buscarCardsDisponibles()">
          <label class="form-check-label small" for="proSoloEsteProy">Solo este proyecto</label>
        </div>
      </div>

      <div *ngIf="modalAttachBuscando" class="text-center text-muted py-3">
        <i class="fa fa-spinner fa-spin me-1"></i>Buscando...
      </div>

      <div *ngIf="!modalAttachBuscando && modalAttachResults.length === 0" class="text-center text-muted py-3">
        Sin resultados.
      </div>

      <div *ngIf="!modalAttachBuscando && modalAttachResults.length > 0" class="pb-attach-list">
        <div *ngFor="let c of modalAttachResults" class="pb-attach-row">
          <div class="pb-attach-info">
            <span class="pb-attach-key">PRO-{{ c.PRO23COD }}</span>
            <span class="pb-attach-tit">{{ c.PRO23TIT }}</span>
            <span class="pb-attach-meta">
              <span *ngIf="c.PRO01COD" class="badge bg-secondary me-1">{{ c.PRO01COD }}</span>
              <span *ngIf="c.PRO30COD" class="badge bg-info me-1">{{ c.PRO30COD }}</span>
              <span *ngIf="c.PRO31COD" class="badge bg-light text-dark me-1">{{ c.PRO31COD }}</span>
              <span *ngIf="c.S00USR" class="text-muted">{{ c.S00USR }}</span>
            </span>
          </div>
          <button class="btn btn-sm btn-success" (click)="attachCard(c)">
            <i class="fa fa-plus"></i> Agregar
          </button>
        </div>
      </div>
    </div>
    <div class="pb-modal-footer">
      <button class="btn btn-sm btn-secondary" (click)="cerrarModalAttach()">Cerrar</button>
    </div>
  </div>

</div>
